import * as React from "react"
import styled from "@digits-css"
import { Lottie } from "@digits-shared/components/UI/Lottie/Lottie"
import { type ButtonSize } from "@digits-shared/DesignSystem/Button"

const Center = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

// extra specificity is needed to prevent button level overrides
const LoaderAnim = styled(Lottie)`
  &[data-size="micro"] {
    height: 8px;
  }
  &[data-size="small"] {
    height: 11px;
  }
  &[data-size="medium"] {
    height: 14px;
  }
  &[data-size="default"] {
    height: 16px;
  }

  svg {
    position: unset !important;
    margin-left: 0 !important;
  }
`

/**
 * Provides a Lottie-based loading animation
 */
export const Loader: React.FC<{ className?: string; size: ButtonSize }> = ({ className, size }) => (
  <LoaderAnim
    className={className}
    aria-label="loading"
    animationData={require("digits-shared/static/lottie/bubble-loader.json")}
    data-size={size}
  />
)

/**
 * Centers a loading animation within the parent container
 */
export const CenteredLoader: React.FC<{ className?: string; size: ButtonSize }> = ({
  className,
  size,
}) => (
  <Center className={className}>
    <Loader size={size} />
  </Center>
)
